require('./externalTransferFundHelp.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const {
    Component
} = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

class ExternalTransferFundHelp extends Component {

    constructor(props) {
        super(props);

        this.handleHideHelp = this.handleHideHelp.bind(this);
    }

    handleHideHelp() {
        this.props.onHideHelp();
    }

    render() {
        const sidebarTitle = formatText('brokerExternalTransferFundHelp-sidebarTitle');
        const sidebarText = formatText('brokerExternalTransferFundHelp-sidebarText');
        const helpBoxTitle = <OKBoxTitle value={formatText('brokerExternalTransferFundHelp-title')} />;

        const helpInfo = (
            <div>
                <div className="col-xs-12 col-md-8">
                    <ContentBox title={helpBoxTitle}>
                        <h4 className="external-transfer-fund-help__header-title">
                            <FormattedText
                                value="brokerExternalTransferFundHelp-howToQuestion"
                            />
                        </h4>
                        <div className="external-transfer-fund-help__text">
                            <FormattedText
                                value="brokerExternalTransferFundHelp-howToAnswer"
                            />
                        </div>
                        <div className="external-transfer-fund-help__field">
                            <div className="external-transfer-fund-help__title">
                                <span className="external-transfer-fund-help__title-number">1</span>
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-step1Title"
                                />
                            </div>
                            <div className="external-transfer-fund-help__text">
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-step1Text"
                                />
                            </div>
                        </div>
                        <div className="external-transfer-fund-help__field">
                            <div className="external-transfer-fund-help__title">
                                <span className="external-transfer-fund-help__title-number">2</span>
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-step2Title"
                                />
                            </div>
                            <div className="external-transfer-fund-help__text">
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-step2Text"
                                />
                            </div>
                        </div>
                        <div className="external-transfer-fund-help__field">
                            <div className="external-transfer-fund-help__title">
                                <span className="external-transfer-fund-help__title-number">3</span>
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-step3Title"
                                />
                            </div>
                            <div className="external-transfer-fund-help__text">
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-step3Text"
                                />
                            </div>
                            <div className="external-transfer-fund-help__text">
                                <FormattedText
                                    value="brokerExternalTransferFundHelp-finalText"
                                />
                            </div>
                            <div className="external-transfer-fund-help__footer">
                                <OKButton onClick={this.handleHideHelp}>
                                    <FormattedText
                                        value="brokerExternalTransferFundStep1-back"
                                    />
                                </OKButton>
                            </div>
                        </div>
                    </ContentBox>
                </div>
                <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                    <ContactInfoBox boxTitle={sidebarTitle} boxBody={sidebarText} />
                </div>
            </div>
        );
        return helpInfo;
    }
}

ExternalTransferFundHelp.propTypes = {
    onHideHelp: PropTypes.func.isRequired
}

module.exports = ExternalTransferFundHelp;